/** Format a date-only value ("YYYY-MM-DD") in the local calendar, no tz drift. */
export const fmtDate = (d: string | null | undefined): string => {
  if (!d) return '';
  const s = d.slice(0, 10);
  const [y, m, day] = s.split('-').map(Number);
  if (!y) return s;
  return new Date(y, m - 1, day).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
};

/** Format an ISO timestamp as a short date+time. */
export const fmtDateTime = (iso: string): string =>
  new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });

/** Relative "time ago" for activity/comments. */
export const timeAgo = (iso: string): string => {
  const then = new Date(iso).getTime();
  const secs = Math.round((Date.now() - then) / 1000);
  if (secs < 60) return 'just now';
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs}h ago`;
  const days = Math.round(hrs / 24);
  if (days < 30) return `${days}d ago`;
  return fmtDate(iso);
};

/** Two hours in seconds — the cutoff past which a comment shows its absolute moment. */
const COMMENT_ABS_AFTER_SECS = 2 * 60 * 60;

/** Timestamp for comments: relative ("just now", "5m ago", "1h ago") for the first two
 *  hours, then the absolute date+time. A day-old comment reads better as "Aug 10, 9:24 PM"
 *  than "21h ago" — the exact moment matters more than the elapsed span. */
export const commentTime = (iso: string): string => {
  const secs = Math.round((Date.now() - new Date(iso).getTime()) / 1000);
  return secs < COMMENT_ABS_AFTER_SECS ? timeAgo(iso) : fmtDateTime(iso);
};
